export const TEXT_SHADOW_OUTLINE =
  "#555 0px 0px 1px,   #555 0px 0px 1px,   #555 0px 0px 1px, #555 0px 0px 1px,   #555 0px 0px 1px,   #555 0px 0px 1px;";
